import * as React from 'react'
import * as TogglePrimitive from '@radix-ui/react-toggle'
import { cva, type VariantProps } from 'class-variance-authority'

import { cn } from '@/lib/utils'

const toggleVariants = cva(
  `inline-flex
  bg-gray-tr-08
  hover:bg-gray-tr-12
  items-center 
  justify-center  
  ring-offset-background 
  transition-colors 
  text-txt-secondary
  font-medium
  hover:text-muted-foreground 
  focus-visible:outline-none 
  focus-visible:ring-2 
  focus-visible:ring-ring 
  focus-visible:ring-offset-2 
  disabled:pointer-events-none 
  disabled:bg-gray-tr-08
  disabled:text-txt-disabled
  `,
  {
    variants: {
      variant: {
        default: `data-[state=on]:bg-accent-default data-[state=on]:text-txt-primary-invers data-[state=on]:hover:bg-accent-high`,
        outline:
          'border border-input hover:bg-accent hover:text-accent-foreground',
      },
      size: {
        default: 'px-3 h-8 text-sm rounded-md',
        sm: 'h-7 px-2 text-xs rounded',
        lg: 'px-4 h-10 text-base rounded-lg',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
    },
  },
)

const Toggle = React.forwardRef<
  React.ElementRef<typeof TogglePrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof TogglePrimitive.Root> &
    VariantProps<typeof toggleVariants>
>(({ className, variant, size, ...props }, ref) => (
  <TogglePrimitive.Root
    ref={ref}
    className={cn(toggleVariants({ variant, size, className }))}
    {...props}
  />
))

Toggle.displayName = TogglePrimitive.Root.displayName

export { Toggle, toggleVariants }
